export const getDefaultSupportEmail = (storeData: any) => {
  if (storeData?.platform_name === "merchfans" || storeData?.is_my_merch == 2) {
    return 'support@merchfans.com'
  }

  if (storeData?.is_my_merch == 0) {
    return ``
  }

  if (storeData?.is_my_merch == 1) {
    return `support@mymerchfactory.com`
  }
  return ''
}

export default getDefaultSupportEmail